import { v4 as uuid4 } from "uuid";

export const taxToTaxRow = (tax: {
  id?: string;
  name: string;
  percentage: number;
  type: string;
  default: boolean;
}) => ({
  id: tax.id || uuid4(),
  name: tax.name,
  percentage: tax.percentage,
  default: tax.default,
});
